var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartjs"},[_c('ChartDoughnut',{attrs:{"label":_vm.theLabel,"labels":_vm.labels,"data":_vm.data,"colors":_vm.colors}}),_c('h3',{staticClass:"chartjs__title"},[_vm._v(_vm._s(_vm.theLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }